/** Physical Supabase relation for published community GHG bulk reads (not legacy precalc). */
export const COMMUNITY_GHG_RELEASE_RELATION = 'community_ghg_inventory_release';

export const COMMUNITY_GHG_RELEASE_META_RELATION = 'community_ghg_inventory_release_meta';

/** Legacy table retained for explicit comparison tooling only. */
export const LEGACY_GHG_INVENTORY_PRECALC_RELATION = 'ghg_inventory_precalculated';
